export default "__VITE_ASSET__22m9gptF__"